import React from 'react'
import { Link } from "react-router-dom";
import './Css/style.css';
import Image from 'react-image-webp';

function index() {
  return (

    <>
       <section className="baner-region">
	
  <div className="container">
  <div className="row">
  <div className="col-md-8 col-xs-12">
  <div className='left-side ml-70'>
    <h3>IV Drip at Home: Rejuvenate Your Well-being in Comfort</h3>
    
    <p className='d-md-none d-lg-none'>In the fast-paced world we live in, maintaining optimal health and vitality can often feel like a challenge. Stress, busy schedules, and the demands of daily life can take a toll on our bodies, leaving us feeling fatigued, dehydrated, and run-down. Introducing our exclusive IV Drip at Home service – a convenient and effective way to revitalize your well-being without the hassle of visiting a clinic.</p>

<p className='mob-noee'>In the fast-paced world we live in, maintaining optimal health and vitality can often feel like a challenge. Stress, busy schedules, and the demands of daily life can take a toll on our bodies, leaving us feeling fatigued, dehydrated, and run-down. Introducing our exclusive IV Drip at Home service – a convenient and effective way to revitalize your well-being without the hassle of visiting a clinic.
</p>
 <Link className="btn btn-warning " to="tel:01206056623">Call Now</Link>

  </div>
  </div>
  
  
  <div className="col-md-4 col-xs-12">
  <div className='right-side'>
  <div className='aft'>
    <img src='/images/Topology-1.svg' alt='topology' />
    </div>
    <div className='tag'>
      <Image
      src={require('../../images/tags-1.png')}
      webp={require('../../images/tags-1.webp')}
      alt='tagsImg'
    />
    </div>
      <Image
      src={require('../../images/bnr-img.png')}
      webp={require('../../images/bnr-img.webp')}
      className='bnrimg img-fluid'
      alt='bnrImg'
    />
    
  </div>
  </div>
  </div>   		
  </div>
  </section>
    </>

  )
}

export default index
